import React from "react";
import GenericInput from "@ui-components/Input/GenericInput";
import {
  InternetP2PAddressing,
  parseVlanInput,
  withSecondaryVlan,
} from "../internetAddressing";

/**
 * The VLAN of the secondary leg (CTX-1132). It is stored in
 * `p2pAddressing.vlanSecondary`, next to the secondary P2P, while the primary
 * VLAN is the service's own `vlan` column. Empty removes it.
 */

export interface SecondaryVlanInputProps {
  p2pAddressing: InternetP2PAddressing;
  error: string | null;
  onUpdate: (p2pAddressing: InternetP2PAddressing) => void;
}

export const SecondaryVlanInput: React.FC<SecondaryVlanInputProps> = ({
  p2pAddressing,
  error,
  onUpdate,
}) => {
  const vlanSecondary = p2pAddressing.vlanSecondary;
  return (
    <GenericInput
      label="VLAN (Secondary)"
      value={
        vlanSecondary === null || vlanSecondary === undefined || Number.isNaN(vlanSecondary)
          ? ""
          : String(vlanSecondary)
      }
      onChange={(value) =>
        onUpdate(withSecondaryVlan(p2pAddressing, parseVlanInput(value)))
      }
      type="number"
      placeholder="Only for a redundant service"
      hasError={error !== null}
      helperText={error ?? undefined}
    />
  );
};
